<template>
  <div id="app" :class="{active : navToggle}">
    <div class="header-placeholder">
      <header>
        <div class="wrap">


          <router-link class="back-btn"
          v-if="$routerHistory.hasPrevious()"
          :to="{ path: $routerHistory.previous().path }">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>Go Back</title><g transform="translate(484 -732)"><circle class="a" cx="12" cy="12" r="11" transform="translate(-484 732)"/><path d="M995.642,1898.267h-9.8c2.212-1.967,4.842-4.336,4.872-4.363a1.038,1.038,0,1,0-1.394-1.537c-.391.352-3.879,3.493-6.079,5.432-.019.017-.037.034-.055.052a1.985,1.985,0,0,0-.023,2.7,1.535,1.535,0,0,0,.114.116l6.25,5.558a1.038,1.038,0,1,0,1.379-1.551l-4.87-4.33h9.609a1.038,1.038,0,0,0,0-2.075Z" transform="translate(-1461.642 -1155.095)"/></g></svg>

          </router-link>




          <button  class="nav-toggle" @click="navToggle = !navToggle">
            <svg v-show="!navToggle" xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
              <g id="Group_121" data-name="Group 121" transform="translate(-1739 -333)">
                <path id="Path_124" data-name="Path 124" d="M0,0H17" transform="translate(1740.5 348.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/>
                <path id="Path_122" data-name="Path 122" d="M0,0H17" transform="translate(1740.5 341.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/>
                <path id="Path_123" data-name="Path 123" d="M0,0H17" transform="translate(1740.5 334.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/>
              </g>
            </svg>
            <svg v-show="navToggle" class="closeNav" xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
              <g>
                <path d="M3.8,14.89l12-12" style="fill: #fff;stroke: #fff;stroke-linecap: round;stroke-width: 3px"/>
                <path d="M4,2.81,16.21,14.69" style="fill: #fff;stroke: #fff;stroke-linecap: round;stroke-width: 3px"/>
              </g>
            </svg>
          </button>
          <h1>Gravitational Wave <br><span class="big-text">Calculator</span></h1>


          <div class="stacked">
            <router-link to="/" class="home-icon" @click.native="closeNav">
              <svg xmlns="http://www.w3.org/2000/svg" width="82" height="77.54" viewBox="0 0 72 77.54"><title>Calculator</title><path class="a" d="M16.62,66.46A5.34,5.34,0,0,0,15,62.55a5.34,5.34,0,0,0-3.92-1.62,5.34,5.34,0,0,0-3.92,1.62,5.54,5.54,0,0,0,0,7.83A5.34,5.34,0,0,0,11.08,72,5.34,5.34,0,0,0,15,70.38,5.34,5.34,0,0,0,16.62,66.46Zm16.62,0a5.54,5.54,0,0,0-5.54-5.54,5.54,5.54,0,1,0,3.92,9.45A5.34,5.34,0,0,0,33.23,66.46ZM16.62,49.85A5.34,5.34,0,0,0,15,45.93a5.34,5.34,0,0,0-3.92-1.62,5.34,5.34,0,0,0-3.92,1.62,5.54,5.54,0,0,0,0,7.83,5.34,5.34,0,0,0,3.92,1.62A5.34,5.34,0,0,0,15,53.76,5.34,5.34,0,0,0,16.62,49.85ZM49.85,66.46a5.54,5.54,0,1,0-1.62,3.92A5.34,5.34,0,0,0,49.85,66.46ZM33.23,49.85a5.54,5.54,0,0,0-5.54-5.54,5.54,5.54,0,1,0,3.92,9.45A5.34,5.34,0,0,0,33.23,49.85ZM16.62,33.23A5.34,5.34,0,0,0,15,29.31a5.34,5.34,0,0,0-3.92-1.62,5.34,5.34,0,0,0-3.92,1.62,5.54,5.54,0,0,0,0,7.83,5.34,5.34,0,0,0,3.92,1.62A5.34,5.34,0,0,0,15,37.15,5.34,5.34,0,0,0,16.62,33.23ZM49.85,49.85a5.54,5.54,0,1,0-1.62,3.92A5.34,5.34,0,0,0,49.85,49.85ZM33.23,33.23a5.54,5.54,0,0,0-5.54-5.54,5.54,5.54,0,0,0-3.92,9.45,5.54,5.54,0,0,0,7.83,0A5.34,5.34,0,0,0,33.23,33.23ZM66.46,66.46V49.85a5.54,5.54,0,0,0-11.08,0V66.46a5.54,5.54,0,0,0,11.08,0ZM49.85,33.23a5.54,5.54,0,1,0-1.62,3.92A5.34,5.34,0,0,0,49.85,33.23ZM66.46,19.38V8.31a2.66,2.66,0,0,0-.82-1.95,2.66,2.66,0,0,0-1.95-.82H8.31a2.66,2.66,0,0,0-1.95.82,2.66,2.66,0,0,0-.82,1.95V19.38a2.66,2.66,0,0,0,.82,1.95,2.66,2.66,0,0,0,1.95.82H63.69a2.81,2.81,0,0,0,2.77-2.77Zm0,13.85a5.54,5.54,0,1,0-1.62,3.92A5.34,5.34,0,0,0,66.46,33.23ZM72,5.54V72a5.62,5.62,0,0,1-5.54,5.54H5.54a5.32,5.32,0,0,1-3.89-1.64A5.32,5.32,0,0,1,0,72V5.54A5.32,5.32,0,0,1,1.64,1.64,5.32,5.32,0,0,1,5.54,0H66.46a5.32,5.32,0,0,1,3.89,1.64A5.32,5.32,0,0,1,72,5.54Z"/></svg>
            </router-link>


            <router-link to="/game" class="home-icon" @click.native="closeNav">
              <svg xmlns="http://www.w3.org/2000/svg" width="211.16" height="237.97" viewBox="-10 -10 201.16 227.97"><title>DIY Universe Game</title><path class="a" d="M74.16,137.87l-.67.61a45.59,45.59,0,0,0,48.06,76l.84-.35a46.68,46.68,0,0,0,13-8.22,45.75,45.75,0,1,0-61.22-68Z"/><path class="a" d="M94.93,88.31l.84-.35a47,47,0,0,0,13-8.21,45.75,45.75,0,0,0-61.22-68l-.68.61a45.59,45.59,0,0,0,48.07,76Z"/><path style="stroke-miterlimit: 10;stroke-width: 12px" class="a" d="M46.75,178.24c-19.83-11.3-34.26-31.21-39.19-55a83.72,83.72,0,0,1,6.18-52.43l4.53,6.87L23.44,50.4.27,65.75l8.67,1.62a89.52,89.52,0,0,0-7.09,57.08c5.29,25.54,20.78,47,42.21,59C48.45,185.87,50.55,180.4,46.75,178.24Z"/><path style="stroke-miterlimit: 10;stroke-width: 12px" class="a" d="M162.76,127.89l-4.22,27.48,22.62-16.16-8.72-1.31a89.54,89.54,0,0,0,5.11-57.3c-6.17-25.33-22.41-46.27-44.23-57.46-4.47-2.3-6.39,3.24-2.51,5.27C151,39,166.14,58.41,171.88,82a83.66,83.66,0,0,1-4.35,52.61Z"/></svg>
            </router-link>


        </div><!-- .stacked -->

        </div>
      </header>
    </div><!-- .header-placeholder -->
    <div class="container">

      <div id="nav" :class="{active : navToggle, minimize : minimizeNav}" @click="closeNav">


          <div class="link-contain">
            <div class="try-me-box">
              <h2><img src="./assets/gold-arrow.svg" alt="arrow"> Try me!</h2>



              <router-link to="/?do=m87" v-tooltip.right="{content:'As postulated by Yonemaru et al (2016)', delay: 0}">
                <span class="gold">M87</span>
              </router-link>
              <router-link to="/?do=3c66b" v-tooltip.right="{content:'As postulated by Sudou et al (2003)', delay: 0}">
                <span class="gold">3C 66B</span>
              </router-link>

            </div><!-- .try-me-box -->

            <router-link to="/"><span>Calculator</span></router-link>
            <router-link to="/game"><span>DIY Universe Game</span></router-link>
            <router-link to="/pulsarmaps"><span>Sensitivity Maps</span></router-link>
            <router-link to="/pulsartiming"><span>Pulsar Timing for Dummies</span></router-link>
            <router-link to="/derivation"><span>Derivation of Formula</span></router-link>
            <router-link to="/about"><span>About Us</span></router-link>
            <router-link to="/citations"><span>Citations</span></router-link>

          </div><!-- .link-contain -->
      </div>

      <div class="min-btn-contain">
        <button @click.prevent="minimizeNav = !minimizeNav" :class="{active : minimizeNav}" title="Show/Hide Navigation"><span>&laquo;</span></button>
      </div><!-- .min-btn-contain -->

      <div id="view">

        <transition name="slide-fade" mode="out-in">
          <router-view :minimize-nav="minimizeNav" />
        </transition>
      </div>

    </div>
  </div>
</template>

<script type="text/javascript">
  export default{
    name: 'app',
    data(){
      return{
        navToggle: false,
        minimizeNav: false
      }
    },
    methods:{
      closeNav: function() {
        if(this.navToggle) { this.navToggle = false; }
      }
    },
    watch: {
      '$route': function() {
        this.navToggle = false
      }
    }
  }
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed:300,400,700|Roboto:400,700');
@import "~vue-directive-tooltip/src/css/index.scss";
$blue: #27AAE1;
$gold: #FCBB07;
$orange: #F7941E;
$paleGold: #FCDB7E;
$grey: #222222;
$break: 678px;

html {
  overflow-y: scroll;
  box-sizing: border-box;
}

.mobile-only{
  @media(min-width: $break){
    display: none;
  }
}

*, *:before, *:after {
  box-sizing: inherit;
}

body {
  font-family: 'Roboto Condensed', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: $grey;
  color: #fff;
  padding: 0;
  padding-bottom: 20px;
  margin: 0;
  text-align: center;
}

a {
  color: #fa5;
}

input[type="text"], input[type="number"] {
  -webkit-appearance: none;
  border-radius: 0;
}

img {
  max-width: 100%;
  height: auto;
}

.header-placeholder{
  height: 160px;

  @media(min-width: $break){
    height: auto;
  }
}

header {
  background: #000;
  margin-bottom: 30px;
  position: relative;
  overflow: hidden;

  &.active{
    @media (max-width: $break){
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background: #000;
      z-index: 20;
    }
  }

  &>.wrap{
    margin: 0 auto;
  }

  h1 {
    margin: 0;
    padding: 1em 0;
    position: relative;
    z-index: 10;
    overflow: hidden;
    text-transform: uppercase;
    font: normal 1.5em/1.3em 'Roboto', sans-serif;

    .big-text{
      padding-bottom:5px;
      border-bottom: solid 4px $blue;
      font-size: 1.65em;
      display: inline-block;
      font-weight: bold;
      letter-spacing: 1px;
    }
  }

  .nav-toggle{
    background: none;
    border: none;
    cursor: pointer;
    outline: none;
    position: relative;
    z-index: 10;
    margin-top: 20px;

    @media (min-width: $break){
      display: none;
    }
  }

  &:before {
    width: 200px;
    height: 200px;
    position: absolute;
    top:-71px;
    left:calc(50% - 100px);
    background: transparent url("./assets/spinning-hole.svg") no-repeat center center;
    content: '';
    display: block;
    animation: spin 12s infinite linear;
    z-index: 5;

    @media (min-width: $break){
      width: 300px;
      height: 300px;
      top:calc(50% - 150px);
      left:calc(50% - 150px);
    }
  }
}



.back-btn, .stacked{
  &, .stacked{
  position: absolute;
  right: 0;
  top: 5px;
  padding: 10px;
  z-index: 11;
  height: 100px;
  }
}

.back-btn{
  height: 40px;
}

.stacked{
  display: flex;
  a:first-of-type{
    margin: 2px 25px 0 0;
  }

  @media(min-width: $break){
     top: 15px;
    display: block;
    a{display: block; height: 40px;}
    a:first-of-type{
      margin: 0 0 10px 0;
    }
  }


}

.home-icon, .back-btn {
  svg {
    width: 24px;
    height: auto;
    .a {
      fill: #27aae1;
      stroke: #27aae1;
      transition: all 0.2s ease;
    }
  }
  &:hover svg .a { fill: #fff; stroke: #fff; }
}
.back-btn{
  right: auto;
  left: 0px;
    @media (min-width: $break){ top: 36px; }
}
@keyframes spin {
  0%   {transform: rotate(0deg); }
  100% {transform: rotate(-360deg); }
}

#app {
  #view{
    max-height: 100%;
    transition: all 0s 0s;
  }

  .min-btn-contain{
    width: 35px;
    display: none;
    @media (min-width: $break) { display: flex; }
    align-items: flex-start;
    padding-top: 70px;

    button{
      position: sticky;
      top: 70px;
      background: $blue;
      color: #000;
      border: none;
      width: 30px;
      height: 30px;
      border-radius: 0 100% 100% 0;
      cursor: pointer;
      outline: none;

      span{
        transition: all 0.5s;
        display: block;
        font-size: 20px;
        line-height: 30px;

      }

      &.active{
        span{
          transform: rotate(180deg) translateY(-2px);
        }
      }
    }
  }

  &.active{
    #view{
      @media (max-width: $break){
        max-height: 0px;
        overflow: hidden;
        transition: all 0s 0.5s;
      }
    }
  }
}

.container {
  display: flex;
  flex-align: flex-start;
  justify-content: center;
}
.container, .wrap {
  max-width: 900px;
  margin: 0 auto;
  position: relative;

  @supports (position: sticky){
    margin: 0 auto;
  }
}

#nav {
  flex: 0 0 305px;
  padding: 30px;
  position: absolute;
  width: 100%;
  min-height: calc(100vh - 160.4px);
  background: #000;
  top: 0;
  left: -150%;
  margin: 0;
  z-index: 100;
  transition: all 0.5s;

  &.active{
    left: 0;
  }

  @media(min-width: $break){
    position: static;
    height: auto;
    border-right: solid 1px $paleGold;
    // margin-right: 35px;
    background: $grey;
    padding: 0 5px 30px 30px;
    overflow: visible;
    box-sizing: border-box;

    .link-contain{
      position: -webkit-sticky;
      position: sticky;
      top: 10px;
      box-sizing: border-box;
      overflow: hidden;
      width: 269px;
      transition: all 0.5s;
    }

    &.minimize{
      flex: 0 0 0px;

      .link-contain{
        width: 0;
      }
    }
  }

  .try-me-box{
    margin-bottom: 30px;
    display: none;

    h2{
      color: $gold;
    }

    @media(min-width: $break){
      display: block;
    }
  }

  h2{
    text-align: left;
    color: $blue;
    max-width: 250px;
    width: 90%;
    margin: 10px auto;
    text-transform: uppercase;

    @media (min-width: $break){
      width: 242px;
    }
  }

  a {
    display: block;
    font-weight: bold;
    color: #fff;
    text-decoration: none;
    border: solid 1px #fff;
    width: 90%;
    max-width: 250px;
    padding: 3px;
    margin: 10px auto;

    @media (min-width: $break){
      width: 242px;
    }


    span{
      color: #000;
      background: #fff;
      width: 100%;
      display: block;
      font-size: 16px;
      padding: 10px;
      transition: all 0.25s;

      &.blue{
        background: $blue;
        color: #fff;
      }

      &.gold{
        background: $gold;
        color: #000;
      }

      @media (min-width: $break){
        &:hover{
          background: $blue;
          color: #fff;
          &.gold {
            background: $orange;
            color: #fff;
          }
        }
      }
    }


    &.router-link-exact-active {
      text-decoration: underline;
      span {
        background: $blue;
        color: #fff;
        &.gold {
          background: $orange;
          color: #fff;
        }
      }
    }
  }
}

#view {
  flex: 3;
  padding: 0 15px;
  text-align: left;
  @media (min-width: $break){
    padding: 0 30px 0 10px;
  }

  h1{
    margin: 20px 0;
    padding: 0;
    font-weight: 300;

    @media (min-width: $break){
      margin: 0;
    }
  }

  .fieldset{
    border: none;
    display: flex;
    flex-wrap: wrap;
    padding: 12px 0;
  }

  .legend, .title{
    font-size: 22px;
    color: $gold;
    display: block;
    border-bottom: dotted 3px $blue;
    width: 100%;
  }
  .title {
    border:none;
    padding: 10px
  }

  p, ul, ol {
    color: $paleGold;
    margin: 1em 0;
  }

  .input-wrap{
    width: 100%;
    margin: 10px 0;

    @media (min-width: 850px){
      flex:1 1 50%;
    }

    input{
      border: solid 1px $blue;
      color: $grey;
      outline: none;
      font-size: 1.1em;
      padding: 10px 10px;
      width: calc(100% - 100px);
      transition: all 0.25s;

      @media (min-width: 850px){
        width: 170px;
        padding: 5px 10px;
      }

      &:focus{
        border: solid 1px $gold;
      }
    }
  }

  .submit-wrap{
    padding: 10px 0;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    background: $grey;

    @media (min-width: 800px){
      justify-content: flex-end;
    }
    &.two {
      display: block;
      &.quad{
        display: flex;
        flex-wrap: wrap;
        .button{
          margin: 10px;
          flex: 0 0 100%;

          span{
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        @media (min-width: 800px){
          justify-content: center;
          .button{
            flex: 0 0 45%;
          }
        }
      }
    }
  }




  .button{
    display: block;
    width: 90%;
    font-weight: bold;
    color: #fff;
    text-decoration: none;
    border: solid 1px #fff;
    width: 100%;
    padding: 5px;
    margin: 10px 0;
    background: none;
    transition: all 0.25s;

    @media (min-width: $break){
      width: 250px;
      padding: 3px;
    }

    span{
      color: #fff;
      background: $orange;
      font-family: 'Roboto Condensed', sans-serif;
      width: 100%;
      height: 100%;
      display: block;
      font-size: 15px;
      padding: 10px 5px;
      text-align: center;
      text-transform: uppercase;
      -webkit-transition: all 0.25s;
      transition: all 0.25s;
      border: none;
      outline: none;
      cursor: pointer;

      strong { font-size: 20px; display: block; }

      @media (min-width: $break){
        padding: 10px;
        font-size: 15px;

          strong { font-size: 28px; display: block; }
      }


    }

    &:hover{
      span{
        background: $gold;
        color: #000;
      }
    }
    &.blue {
      span { background: $blue; }
      &:hover { span { background: #fff; color: #000; } }
    }
    &.white {
      span { background: #fff; color: #000; padding: 5px; }
      &:hover { span { background: #555; color: #fff; } }
    }
  }


}

.slide-fade-enter-active {
  transition: all .4s ease-out;
}
.slide-fade-leave-active {
  transition: all .3s ease-in;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-15px) scale(0.98);
  transform-origin: 50% 200px;
  opacity: 0.1;
}
.vue-tooltip { font-style: italic; font-size: 0.9em; }
.tooltip-arrow { background: none; }
</style>
